import { useState, useEffect } from 'react';

export function useFormatTime(initialSeconds) {
  const [countdownSeconds, setCountdownSeconds] = useState(initialSeconds || 0);
  const [isFinished, setIsFinished] = useState(false);
  
  const formatTime = (seconds) => {
    const total = Math.max(0, Math.floor(seconds || 0));
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
  
  useEffect(() => {
    setCountdownSeconds(initialSeconds);
    setIsFinished(false);
  }, [initialSeconds]);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCountdownSeconds(prev => {
        const newValue = Math.max(0, prev - 1);
        if (newValue === 0 && prev > 0) {
          setIsFinished(true);
        }
        return newValue;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  
  if (!Boolean(initialSeconds) && +initialSeconds === 0) {
    return {
      initialMinutes: 0,
      initialFormattedSeconds: '00',
      initialFormattedTime: '0:00',
      countdownFormattedTime: '0:00',
      isValidTime: false,
      isFinished: false
    };
  }

  const initialMinutes = Math.floor(initialSeconds / 60);
  const initialRemainingSeconds = initialSeconds % 60;
  const initialFormattedSeconds = initialRemainingSeconds.toString().padStart(2, '0');
  const initialFormattedTime = `${initialMinutes}:${initialFormattedSeconds}`;
  
  return {
    initialMinutes,
    initialFormattedSeconds,
    initialFormattedTime,
    countdownFormattedTime: formatTime(countdownSeconds),
    isValidTime: true,
    isFinished
  };
}